module.exports = {
      id: "minus-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#minus",
      toString: function () {
        return this.url;
      }
    }